import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import './intercept';
import get from 'lodash/get';
import { isSafari, isIE, browserVersion, isChrome, isFirefox, isMacOs } from 'react-device-detect';
import { Grid } from '@material-ui/core';

// Components
import AlertOutdatedBrowser from '../components/AlertOutdatedBrowser';
import SuccessModal from '../components/modal/SuccessModal';

// Redux
import { promptUser } from '../redux/actions/notificationsActions';
import { closeSuccessModal } from '../redux/actions/modalActions';

// Helpers
import withNotifications from '../helpers/NotificationsHoc';
import withPrompts from '../helpers/PromptsHoc';

class MainWrapper extends PureComponent {
  componentDidMount() {
    if (this.validVersionsBrowsers()) {
      return this.props
        .promptUser({
          title: 'Version del navegador desactualizado',
          message:
            'La version del navegador que estas utilizado esta desactualizada, te invitamos a descargar una version mas reciente de tu navegador',
          color: 'info'
        })
        .then(confirmation => {
          console.log(confirmation);
        });
    }
  }

  validVersionsBrowsers = () => {
    if (isChrome && browserVersion < 70) return true;
    if (isFirefox && browserVersion < 65) return true;

    return false;
  };

  invalidBrowsers = () => {
    if (isIE) return false;
    if (isSafari && browserVersion < 11 && isMacOs) return false;

    return true;
  };

  isLogin = href => {
    if (href.indexOf('login') > 0) return true;
    if (href.indexOf('signup') > 0) return true;

    return false;
  };

  typeContent = () => {
    let wrapperClass = classNames({
      'wrapper--full-width': this.props.sidebar.collapse,
      'squared-corner-theme': this.props.detailsPanel.squaredCorners,
      'blocks-with-shadow-theme': this.props.detailsPanel.withBoxShadow,
      'top-navigation': this.props.detailsPanel.topNavigation
    }); // END wrapperClass

    const theme = this.props.theme.className;
    const { showModal, closeSuccessModal, title, message, text_button = 'Finalizar' } = this.props;

    if (!this.invalidBrowsers()) {
      return (
        <div className={theme}>
          <AlertOutdatedBrowser />
        </div>
      );
    } else {
      return (
        <div className={theme}>
          <div className={wrapperClass}>
            <SuccessModal open={showModal} title={title} successAction={closeSuccessModal} textButton={text_button}>
              <Grid container>
                <Grid xs={12} className="text_success_modal_grid" item>
                  {message}
                </Grid>
              </Grid>
            </SuccessModal>
            {this.props.children}
          </div>
        </div>
      );
    }
  };

  render() {
    return this.typeContent();
  }
}

MainWrapper.propTypes = {
  promptUser: PropTypes.func,
  closeSuccessModal: PropTypes.func,
  sidebar: PropTypes.object,
  detailsPanel: PropTypes.object,
  appUser: PropTypes.any,
  theme: PropTypes.object,
  showModal: PropTypes.bool,
  message: PropTypes.string,
  title: PropTypes.string,
  text_button: PropTypes.string,
  children: PropTypes.node
};

export default connect(
  state => ({
    appUser: state.account,
    theme: state.theme,
    sidebar: state.sidebar,
    detailsPanel: state.detailsPanel,
    showModal: get(state, 'modal.show'),
    message: get(state, 'modal.message'),
    title: get(state, 'modal.title'),
    text_button: get(state, 'modal.text_button'),
    alertDisplayed: get(state, 'account.alertDisplayed')
  }),
  { promptUser, closeSuccessModal }
)(withNotifications(withPrompts(MainWrapper)));



// WEBPACK FOOTER //
// ./src/app/MainWrapper.js